import { LOADING_MESSAGES } from '@buzunarul/shared-constants';
import React from "react";
import { cn } from '../../../styles/cva-v2';
import { spinner, type SpinnerProps as SpinnerVariants } from '../../../styles/cva-v2/primitives';

export interface SpinnerProps extends SpinnerVariants {
  className?: string;
  'aria-label'?: string;
}

/**
 * 🔄 SPINNER COMPONENT - CVA-v2 Migrated
 *
 * 🎨 Design System Integration:
 * - Uses CVA-v2 spinner primitive for consistent styling
 * - Carbon Copper palette variants (default, primary, success, warning, error, white)
 * - Responsive sizes (xs, sm, md, lg, xl) with proper border weights
 * - Motion-reduce support for accessibility
 *
 * 🧠 Architecture:
 * - Pure border-based spinner (lightweight, performant)
 * - Semantic role="status" for screen readers
 * - Customizable aria-label for context-specific loading messages
 *
 * ⚙️ Migration Notes:
 * - Migrated from custom size/color classes to CVA-v2 primitive
 * - Simplified from SVG to border-based approach
 * - Maintains all accessibility features
 */
const Spinner = ({
  size = "md",
  variant = "primary",
  className,
  'aria-label': ariaLabel,
  ...props
}: SpinnerProps) => {
  return (
    <div
      className={cn(spinner({ size, variant }), className)}
      role="status"
      aria-label={ariaLabel || LOADING_MESSAGES.GENERIC}
      {...props}
    >
      <span className="sr-only">{ariaLabel || LOADING_MESSAGES.GENERIC}</span>
    </div>
  );
};

export default Spinner;
